import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import bounceInBottomGif from '../../../assets/images/transitions/bounceInBottom.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_BOUNCE_IN_BOTTOM = 'bounceInBottom';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   humanName: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const bounceInBottomPresetDetails = {
  // The name of the preset.
  name: PRESET_BOUNCE_IN_BOTTOM,

  // A human friendly name for the preset.
  humanName: 'Bounce In From Bottom',

  // A preview of the transition.
  gif: bounceInBottomGif,

  // The element names that this preset can be used for or true for all elements.
  elements: true,

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'in',

  // Each property that will change during the transition.
  details: {
    'position.y': {
      // The name of the easing this property will use.
      easing: EASINGS.easeOutElastic,

      // The start and end times for the transition of this property.
      time: {
        start: 'start.0',
        end: 'start.1300',
      },

      // The value of the property that will change during the transition.
      values: [
        'off.bottom',
        'position.bottom'
      ],
    },
    immediateRender: true
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_BOUNCE_IN_BOTTOM,
    options: {},
  },
};

bounceInBottomPresetDetails.template.options = lodash.cloneDeep(bounceInBottomPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_BOUNCE_IN_BOTTOM;

// This defines the value of the presets object.
export default bounceInBottomPresetDetails;
